import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { MatChipInputEvent } from '@angular/material/chips';

import { Component, Input, Output, EventEmitter } from "@angular/core";

export interface Item {
    name: string;
}

@Component({
    selector: 'material-chips',
    template: `
    <mat-form-field class="chip-list" [style.fontSize]="fontSize" appearance="{{appearance}}">
    <mat-label>{{label}}</mat-label>
    <mat-chip-list #chipList aria-label="Item selection">
        <mat-chip *ngFor="let item of items" [selectable]="selectable"
                [removable]="removable" (removed)="remove(item)">
        {{item.name}}
        <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
        </mat-chip>
        <input placeholder="{{placeholder}}"
            [matChipInputFor]="chipList"
            [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
            [matChipInputAddOnBlur]="addOnBlur"
            (matChipInputTokenEnd)="add($event)">
    </mat-chip-list>
    </mat-form-field>
    `,
    styles: [`
    .chip-list {
        width: 100%;
      }
      `]
})

export class MaterialChips {
    @Input() placeholder: string = '';
    @Input() label: string = '';
    @Input() items: Item[] = [];
    @Input() appearance: string = 'fill';
    @Input() fontSize:string = '14px';

    @Output() result = new EventEmitter();

    selectable = true;
    removable = true;
    addOnBlur = true;
    readonly separatorKeysCodes = [ENTER, COMMA] as const;
    // items: Item[] = [
    //     // { name: 'Lemon' },
    //     // { name: 'Lime' },
    //     // { name: 'Apple' },
    // ];

    add(event: MatChipInputEvent): void {
        const value = (event.value || '').trim();

        // Add our fruit
        if (value) {
            this.items.push({ name: value });
        }

        // Clear the input value
        // event.chipInput!.clear();

        // Reset the input value
        if (event.input) {
            event.input.value = '';
        }

        this.eventFired();

    }

    remove(item: Item): void {
        const index = this.items.indexOf(item);

        if (index >= 0) {
            this.items.splice(index, 1);
        }

        this.eventFired();
    }

    eventFired() {
        // console.log(this.items);
        this.result.emit(this.items);
    }
}